/** @file Reads one text field of a submitted form (files and missing fields read as ''). */

/** The string value of `name` in `form`, or '' when absent or a File. */
export function formField(form: FormData, name: string): string {
  const value = form.get(name);
  return typeof value === 'string' ? value : '';
}
